"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VERSION = void 0;
const package_json_1 = require("../package.json");
exports.VERSION = package_json_1.version;
//# sourceMappingURL=version.js.map